export default __webpack_public_path__ + "c.ab7ed8aa.png";